<template>
  <div style="color: white; text-align: center;">
    <h1>Espere por favor</h1>
    <h3>CARGANDO...</h3>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  mounted() {
    const email = this.$route.params.user;
    const password = this.$route.params.password;
    let params = new URLSearchParams();
    params.append("email", email);
    params.append("password", password);
    let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };
    axios.post(`${url}session`, params, headers).then((response) => {
      this.setearCargando(true);
      if (response.status == 200 && response.data.readonly == false) {
        sessionStorage.aleatorio = 1379248;
        sessionStorage.email = email;
        sessionStorage.password = password;
        this.$router.push({ name: "home" });
        var token = btoa(email + ":" + password);
        headers = { 'Authorization': "basic " + token };
        localStorage.user = JSON.stringify({ headers: { 'Authorization': "basic " + token } });
      }
      this.$root.$emit('errorLogin', [1, email, password]);
    }).catch(() => {
      this.setearCargando(false);
      this.$router.push({ name: "login" });
      this.$root.$emit('errorLogin', [2, email, password]);
      this.$root.test = [2, email, password];
      // alert('Usuario o contraseña mal escrito');
    });;
  },
  computed: {
    ...mapState(["cargando"]),
  },
  methods: {
    ...mapMutations(["setearCargando"]),
    ...mapActions("catalogos", ["obtenerUnidades"]),
  },
};
</script>
